import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { startNotificationConnection } from "./services/signalR";

import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import ForgotPass from "views/auth/Forgotpass";
import PersistLogin from "./components/PersistLogin";
import RequireAuth from "./components/RequireAuth";
import axios from "./api/axios";

const App = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchNotifications = async () => {
    try {
      const token =
        "Bearer " + localStorage.getItem("token")?.replace(/"/g, "");
      const res = await axios.get("/api/dashboard-notifications", {
        headers: { Authorization: token },
      });
      setNotifications(
        res.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      );
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  fetchNotifications(); // initial load

  startNotificationConnection(
    () => {
      console.log("🔔 AdminReportAdded received");
      fetchNotifications(); // fetch admin notifications
    },
    () => {
      console.log("🔔 PoliceReportApproved received");
      fetchNotifications(); // fetch police notifications
    }
  );
}, []);
  return (
    <>
      <Routes>
        <Route path="/auth/*" element={<AuthLayout />} />
        <Route path="/forgot-password/" element={<ForgotPass />} />
        <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />

        <Route element={<PersistLogin />}>
          <Route
            element={
              <RequireAuth
                allowedRoles={[
                  "admin",
                  "admin_assistant",
                  "admin_police",
                  "assistant_police",
                ]}
              />
            }
          >
            {/* IMPORTANT FIX HERE */}
            <Route
              path="/admin/*"
              element={
                // Pass notifications and fetchNotifications down
                <AdminLayout
                  notifications={notifications}
                  setNotifications={setNotifications}
                  fetchNotifications={fetchNotifications}
                />
              }
            />
          </Route>
        </Route>
      </Routes>
    </>
  );
};

export default App;
